/* Fore2Feet theme: header menu, scroll state, cart count. Feature scripts (carousel, quiz, cart...) live in their own assets. */
(function () {
  var header = document.querySelector('[data-site-header]');
  if (header) {
    var lastY = Math.max(0, window.scrollY);
    var update = function () {
      var y = Math.max(0, window.scrollY);
      header.classList.toggle('is-scrolled', y > 24);
      if (y < 100 || header.querySelector('[data-menu].open')) { header.classList.remove('is-scroll-hidden'); lastY = y; return; }
      if (Math.abs(y - lastY) < 8) return;
      header.classList.toggle('is-scroll-hidden', y > lastY);
      lastY = y;
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
  }
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-menu]');
  if (toggle && menu) {
    var setOpen = function (open) {
      menu.classList.toggle('open', open);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.textContent = open ? toggle.dataset.openLabel : toggle.dataset.closedLabel;
    };
    toggle.addEventListener('click', function () { setOpen(toggle.getAttribute('aria-expanded') !== 'true'); });
    menu.addEventListener('click', function (e) { if (e.target.closest('a')) setOpen(false); });
  }
  window.F2F = window.F2F || {};
  window.F2F.refreshCartCount = function () {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      document.dispatchEvent(new CustomEvent('f2f:cart', { detail: cart }));
      return cart;
    });
  };
})();

/* Any element with data-open-offer opens the welcome offer popup. */
document.addEventListener('click', function (event) {
  if (event.target.closest && event.target.closest('[data-open-offer]')) window.dispatchEvent(new Event('fit-offer-open'));
});
